import React from "react";
import { useNavigate } from "react-router-dom";

const TemuTicket = () => {
  const navigate = useNavigate();
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="temu-history-wrapper">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-temuTicket mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span style={{paddingLeft:"0"}} className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">TEMU Ticket history</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div className="temu-history-wrap">
          <div className="history-header">
            <div className="header-img">
              <img src="/assets/images/temu-history-box.5cd73118.gif" alt />
            </div>
            <div className="header-amount">
              <div className="amount-title">Total Claimed Amount</div>
              <div className="amount-balance-common amount-item">
                <span className="currency ">৳</span>
                {/* react-text: 6568 */}&nbsp;{/* /react-text */}
                <span className="number-mc undefined">
                  <div className="wysiwyg">
                    0.<label className="small">00</label>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div className="history-list">
            <div className="nodata-container" style={{ height: "457.7px" }}>
              <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                <use xlinkHref="#nodata_f4c19c2d" />
              </svg>
              <p className>No data</p>
            </div>
            <div
              className="list-wrapper"
              style={{ height: "calc(100 * var(--vh, 1vh) - 760PX)" }}
            >
              <ul
                className="scroll-inner-container"
                style={{
                  "-webkit-transition-timing-function":
                    "cubic-bezier(0.165, 0.84, 0.44, 1)",
                  "transition-timing-function":
                    "cubic-bezier(0.165, 0.84, 0.44, 1)",
                  "-webkit-transition-duration": "0ms",
                  "transition-duration": "0ms",
                  "-webkit-transform":
                    "translate(0px) scale(1) translateZ(0px)",
                  "-ms-transform": "translate(0px) scale(1) translateZ(0px)",
                  transform: "translate(0px) scale(1) translateZ(0px)",
                }}
              >
                <li />
              </ul>
              <div className="pullup-wrapper" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemuTicket;
